module.exports = __webpack_public_path__ + "static/media/big-exclamation-icon.57fe2584.svg";